import React, {useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {useGetQuery} from "../../hooks/useQueryHooks";
import {ResponseList} from "../../models/clientModels/interfaces/Response";

import {
  Box,
  Button,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import * as workOrderApi from "../../api/workOrderApi/workOrderApi";
import MWSkeleton from "../../components/MWSkeleton";
import SubTitle from "../../components/SubTitle";
import {typeValue} from "../../models/clientModels/data/selectList";
import {EQWorkOrder, getSerialNumber} from "../../models/serverModels/workOrder/EQWorkOrder";
import {PaginationContainer} from "../../styledComponents/StyledPagination";
import {StyledNoneScrollTable, StyledNoneStickyTable} from "../../styledComponents/StyledTable";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1500px",
}));

const MaintenanceList = () => {
  const {state} = useParams();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const [page, setPage] = useState<number>(1);

  const {
    data: documentList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EQWorkOrder>>({
    key: [
      "MaintenanceList",
      {
        state,
        token: tokenState,
        page,
      },
    ],
    api: () =>
      workOrderApi.maintenanceList({
        state,
        token: tokenState,
        page,
      }),
  });

  const subTitleChange = () =>
    state === "Received"
      ? "점검의뢰 수신목록"
      : state === "Processed"
      ? "점검의뢰 진행목록"
      : state === "Completed"
      ? "점검의뢰 완료목록"
      : "";

  const paginationHandleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  return (
    <ListContainer>
      <SubTitle subTitle={subTitleChange()}>
        {/* {state === "Received" && (
          <Button
            variant="contained"
            size="small"
            sx={{marginLeft: "18px"}}
            startIcon={<ArticleIcon />}
          >
            서식다운로드
          </Button>
        )} */}
      </SubTitle>
      <StyledNoneScrollTable style={{marginTop: "16px"}}>
        <Table>
          <StyledNoneStickyTable>
            <TableRow>
              <TableCell align="center">일련번호</TableCell>
              <TableCell align="center">요청부서</TableCell>
              <TableCell align="center">작성자</TableCell>
              <TableCell align="center">분류</TableCell>
              <TableCell align="center">설비번호</TableCell>
              <TableCell align="center">설비명</TableCell>
              <TableCell align="center">위험등급</TableCell>
              <TableCell align="center">요청내용</TableCell>
              <TableCell align="center">요청날짜</TableCell>
              {state === "Received" && <TableCell align="center">상태</TableCell>}
              {state === "Processed" && <TableCell align="center">상태</TableCell>}
            </TableRow>
          </StyledNoneStickyTable>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={9} />
            ) : (
              documentList?.items.map((item) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    <Link to={`/WorkOrder/View/${item.uid}`}> {getSerialNumber(item)}</Link>
                  </TableCell>
                  <TableCell align="center">{item.department}</TableCell>
                  <TableCell align="center">{item.writerName}</TableCell>
                  <TableCell align="center">
                    {typeValue?.map((v) => (v.value === item.specification?.type ? v.label : ""))}
                  </TableCell>
                  <TableCell align="center">{item.specification?.identifyNumber}</TableCell>
                  <TableCell align="center">{item.specification.name}</TableCell>
                  <TableCell align="center">{item.specification.eqLevel}</TableCell>
                  <TableCell align="center">{item.requestContent}</TableCell>
                  <TableCell align="center">
                    {new Date(item?.requestDate).getFullYear()}년
                    {new Date(item?.requestDate).getMonth() + 1}월
                    {new Date(item?.requestDate).getDate()}일
                  </TableCell>
                  {state === "Received" && (
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        style={{marginRight: "12px"}}
                        onClick={() => {
                          navigate(`/WorkOrder/Process`, {state: {uid: item.uid, list: state}});
                        }}
                      >
                        진행
                      </Button>
                      <Button
                        variant="contained"
                        color="info"
                        size="small"
                        style={{marginRight: "12px"}}
                        onClick={() => {
                          navigate(`/WorkOrder/Reject`, {state: {uid: item.uid, list: state}});
                        }}
                      >
                        반려
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          navigate(`/WorkOrder/Delay`, {state: {uid: item.uid, list: state}});
                        }}
                      >
                        지연
                      </Button>
                    </TableCell>
                  )}
                  {state === "Processed" && (
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="success"
                        size="small"
                        style={{marginRight: "12px"}}
                        onClick={() => {
                          navigate(`/WorkOrder/Complete`, {state: {uid: item.uid, list: state}});
                        }}
                      >
                        완료
                      </Button>
                      <Button
                        variant="contained"
                        color="info"
                        size="small"
                        style={{marginRight: "12px"}}
                        onClick={() => {
                          navigate(`/WorkOrder/Reject`, {state: {uid: item.uid, list: state}});
                        }}
                      >
                        반려
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          navigate(`/WorkOrder/Delay`, {state: {uid: item.uid, list: state}});
                        }}
                      >
                        지연
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledNoneScrollTable>
      {/* 페이지네이션 */}
      <PaginationContainer>
        <Pagination
          count={documentList?.maxPage}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer>
    </ListContainer>
  );
};

export default MaintenanceList;
